import axios from 'axios';

// In production, use relative URL so nginx proxy handles routing
// In development, use localhost:8000
const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8000/api'
);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Strategies API
export const strategiesAPI = {
  list: () => api.get('/strategies'),
  get: (id) => api.get(`/strategies/${id}`),
  create: (data) => api.post('/strategies', data),
  update: (id, data) => api.put(`/strategies/${id}`, data),
  delete: (id) => api.delete(`/strategies/${id}`),
  backtest: (id) => api.post(`/strategies/${id}/backtest`),
};

// Stocks API
export const stocksAPI = {
  analyze: (symbol, config) => api.post('/stocks/analyze', { symbol, strategy_config: config }),
  getChart: (symbol, period) => api.get(`/stocks/${symbol}/chart`, { params: { period } }),
  get: (symbol) => api.get(`/stocks/${symbol}`),
};

// Signals API
export const signalsAPI = {
  list: (params, config) => api.get('/signals', { params, ...config }),
  get: (id) => api.get(`/signals/${id}`),
  scan: () => api.post('/signals/scan'),
};

// Watchlist API
export const watchlistAPI = {
  list: () => api.get('/watchlist'),
  add: (symbol) => api.post('/watchlist', { symbol }),
  remove: (id) => api.delete(`/watchlist/${id}`),  search: (query) => api.get(`/watchlist/search/${query}`),
  validate: (symbol) => api.get(`/watchlist/validate/${symbol}`),};

// Settings API
export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  verify: (token) => api.get('/auth/verify', { params: { token } }),
};

// Health check
export const healthCheck = () => api.get('/health');

export default api;
